import { toast, TypeOptions } from 'react-toastify';

export function useNotification() {
  return (notification: string | JSX.Element, options: TypeOptions | { type: TypeOptions }) => {
    const type = typeof options === 'string' ? options : options.type;
    return type !== 'default'
      ? toast[type](notification, {
          position: 'top-right',
        })
      : toast(notification, {
          position: 'top-right',
          hideProgressBar: true,
          autoClose: false,
          closeButton: false,
          closeOnClick: true,
        });
  };
}
